import React, { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListaPesquisaSatisfacaoRespostasFormularioHelpdeskController } from "../../../../Controllers/Geral/Formularios/FormulariosControllers";
import { ListarPerguntasERespostarFormController } from "../../../../Controllers/Geral/Formularios/PerguntasERespostas/PerguntasERespostasControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IListagemDasPesquisasSatisfacaoRelatorios } from "../../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import { formatedTelefone } from "../../../../Tools/FormatTools";

interface IModalVisualizarPesquisaSatisfacao {
    setShow: Dispatch<SetStateAction<boolean>>;
    visualizandoFormRespondido?: boolean;
    idContaChat?: number;
    idFormulario?: number;
    lstPesquisaSatisfacao?:
        | IListagemDasPesquisasSatisfacaoRelatorios
        | undefined;
    idCaso?: number;
}

export default function ModalVisualizarPesquisaSatisfacao(
    props: IModalVisualizarPesquisaSatisfacao
) {
    const {
        value: lstPesquisaSatisfacaoRespostasFormularioHelpdesk,
        loading: lstPesquisaSatisfacaoRespostasFormularioHelpdeskLoading,
    } = useAsyncEffect(async () => {
        if (props.idContaChat || props.idCaso) {
            return ListaPesquisaSatisfacaoRespostasFormularioHelpdeskController(
                props.idContaChat ?? 0,
                props.idCaso ?? 0
            );
        }
    }, [props.visualizandoFormRespondido]);

    const { value: ListarFormulario, loading: ListarFormularioLoading } =
        useAsyncEffect(async () => {
            if (props.idFormulario)
                return ListarPerguntasERespostarFormController(
                    props.idFormulario
                );
        });

    return (
        <>
            <OrSpinner
                loading={
                    lstPesquisaSatisfacaoRespostasFormularioHelpdeskLoading ||
                    ListarFormularioLoading
                }
                spinner="capys"
            >
                <div className="p-4">
                    <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                        <h3>{ListarFormulario?.DS_FORMULARIO}</h3>
                    </div>

                    {props.lstPesquisaSatisfacao?.DS_NOME && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">Nome:</span>{" "}
                                {props.lstPesquisaSatisfacao?.DS_NOME}
                            </span>
                        </div>
                    )}

                    {props.lstPesquisaSatisfacao?.DT_INICIO_CHAT && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">
                                    Dt. Inicial do chat:
                                </span>{" "}
                                {new Date(
                                    props.lstPesquisaSatisfacao?.DT_INICIO_CHAT
                                ).toLocaleDateString()}
                            </span>
                        </div>
                    )}

                    {props.lstPesquisaSatisfacao?.DT_FIM_CHAT && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">
                                    Dt. Final do chat:
                                </span>{" "}
                                {new Date(
                                    props.lstPesquisaSatisfacao?.DT_FIM_CHAT
                                ).toLocaleDateString()}
                            </span>
                        </div>
                    )}

                    {props.lstPesquisaSatisfacao?.DT_ASSINATURA && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">
                                    Dt. Assinatura:
                                </span>{" "}
                                {new Date(
                                    props.lstPesquisaSatisfacao?.DT_ASSINATURA
                                ).toLocaleDateString()}
                            </span>
                        </div>
                    )}

                    {props.lstPesquisaSatisfacao?.DS_NOME_ATENDENTE && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">
                                    Nome do Atendente:
                                </span>{" "}
                                {props.lstPesquisaSatisfacao?.DS_NOME_ATENDENTE}
                            </span>
                        </div>
                    )}

                    {props.lstPesquisaSatisfacao?.NR_TELEFONE && (
                        <div className="d-flex flex-column">
                            <span style={{ fontSize: 18 }}>
                                <span className="font-weight-bold">
                                    Telefone:
                                </span>{" "}
                                {formatedTelefone(
                                    props.lstPesquisaSatisfacao?.NR_TELEFONE
                                )}
                            </span>
                        </div>
                    )}

                    <UnForm handleSubmit={() => {}}>
                        {ListarFormulario?.ListaPesquisaSatisfacaoPerguntaRespostas?.map(
                            (perguntaPai, index) => (
                                <div
                                    key={perguntaPai.ID_PERGUNTA}
                                    className={`h-100 mb-5 wrap ${
                                        perguntaPai.ID_PERGUNTA_PAI &&
                                        "ml-25 mb-0 mt-0 mr-25"
                                    } ${!perguntaPai.FL_ATIVO && "d-none"}`}
                                >
                                    <>
                                        <hr className="mb-5 mt-5" />
                                        <h4>{perguntaPai.DS_PERGUNTA}</h4>
                                    </>

                                    <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                        {perguntaPai.ID_TIPO_PERGUNTA !== 3 ? (
                                            <>
                                                {perguntaPai.PesquisaSatisfacaoRespostas?.map(
                                                    (resposta) => (
                                                        <React.Fragment
                                                            key={
                                                                resposta.ID_RESPOSTA
                                                            }
                                                        >
                                                            <li
                                                                className="m-5"
                                                                style={{
                                                                    height: 80,
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    justifyContent:
                                                                        "center",
                                                                    flexDirection:
                                                                        "column",
                                                                    textAlign:
                                                                        "center",
                                                                }}
                                                            >
                                                                <UnForm.Input
                                                                    readOnly
                                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                    value={
                                                                        perguntaPai.ID_PERGUNTA
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            "none",
                                                                    }}
                                                                    wrapperClassName="d-none"
                                                                    disabled={
                                                                        props.visualizandoFormRespondido ===
                                                                        true
                                                                    }
                                                                    defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                        (res) =>
                                                                            res.ID_RESPOSTA ===
                                                                            resposta.ID_RESPOSTA
                                                                    )}
                                                                />

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                1 ? (
                                                                    <UnForm.Input
                                                                        name={`Respondidas.${index}.idRespostas.0`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        type={
                                                                            "radio"
                                                                        }
                                                                        wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                        disabled={
                                                                            props.visualizandoFormRespondido ===
                                                                            true
                                                                        }
                                                                        defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                            (
                                                                                res
                                                                            ) =>
                                                                                res.ID_RESPOSTA ===
                                                                                resposta.ID_RESPOSTA
                                                                        )}
                                                                    />
                                                                ) : null}

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                2 ? (
                                                                    <UnForm.Input
                                                                        type="checkbox"
                                                                        color="primary"
                                                                        name={`Respondidas.${index}.idRespostas`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                        wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                        disabled={
                                                                            props.visualizandoFormRespondido ===
                                                                            true
                                                                        }
                                                                        defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                            (
                                                                                res
                                                                            ) =>
                                                                                res.ID_RESPOSTA ===
                                                                                resposta.ID_RESPOSTA
                                                                        )}
                                                                    />
                                                                ) : null}
                                                            </li>
                                                        </React.Fragment>
                                                    )
                                                )}
                                            </>
                                        ) : null}
                                    </ul>

                                    {!perguntaPai.ID_PERGUNTA_PAI && (
                                        <>
                                            <UnForm.Textarea
                                                label={
                                                    perguntaPai.ID_TIPO_PERGUNTA ===
                                                    3
                                                        ? "Resposta"
                                                        : "Comentário"
                                                }
                                                name={`Respondidas.${index}.DS_COMENTARIO`}
                                                defaultValue={
                                                    lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.[
                                                        index
                                                    ]?.DS_COMENTARIO
                                                }
                                                disabled={
                                                    props.visualizandoFormRespondido ===
                                                    true
                                                }
                                            />
                                        </>
                                    )}

                                    {perguntaPai.PerguntasFilhas?.map(
                                        (pergunta) => (
                                            <div className="h-100 mb-5 wrap ml-25 mb-0 mt-0 mr-25 false">
                                                <div className="mt-8">
                                                    <h4>
                                                        {
                                                            perguntaPai.DS_PERGUNTA
                                                        }
                                                    </h4>
                                                </div>
                                                <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                                    {pergunta.ID_TIPO_PERGUNTA !==
                                                    3 ? (
                                                        <>
                                                            {pergunta.PesquisaSatisfacaoRespostas.map(
                                                                (resposta) => (
                                                                    <React.Fragment
                                                                        key={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                    >
                                                                        <li
                                                                            className="m-5"
                                                                            style={{
                                                                                height: 80,
                                                                                display:
                                                                                    "flex",
                                                                                alignItems:
                                                                                    "center",
                                                                                justifyContent:
                                                                                    "center",
                                                                                flexDirection:
                                                                                    "column",
                                                                                textAlign:
                                                                                    "center",
                                                                            }}
                                                                        >
                                                                            <UnForm.Input
                                                                                readOnly
                                                                                name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                                value={
                                                                                    pergunta.ID_PERGUNTA
                                                                                }
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                                wrapperClassName="d-none"
                                                                                disabled={
                                                                                    props.visualizandoFormRespondido ===
                                                                                    true
                                                                                }
                                                                                defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                                    (
                                                                                        res
                                                                                    ) =>
                                                                                        res.ID_RESPOSTA ===
                                                                                        resposta.ID_RESPOSTA
                                                                                )}
                                                                            />

                                                                            {pergunta.ID_TIPO_PERGUNTA ===
                                                                            1 ? (
                                                                                <UnForm.Input
                                                                                    name={`Respondidas.${index}.idRespostas.0`}
                                                                                    label={
                                                                                        resposta.DS_RESPOSTA
                                                                                    }
                                                                                    type={
                                                                                        "radio"
                                                                                    }
                                                                                    wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                                    style={{
                                                                                        height: 35,
                                                                                        width: 35,
                                                                                    }}
                                                                                    value={
                                                                                        resposta.ID_RESPOSTA
                                                                                    }
                                                                                    disabled={
                                                                                        props.visualizandoFormRespondido ===
                                                                                        true
                                                                                    }
                                                                                    defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                                        (
                                                                                            res
                                                                                        ) =>
                                                                                            res.ID_RESPOSTA ===
                                                                                            resposta.ID_RESPOSTA
                                                                                    )}
                                                                                />
                                                                            ) : null}

                                                                            {pergunta.ID_TIPO_PERGUNTA ===
                                                                            2 ? (
                                                                                <UnForm.Input
                                                                                    type="checkbox"
                                                                                    color="primary"
                                                                                    name={`Respondidas.${index}.idRespostas`}
                                                                                    label={
                                                                                        resposta.DS_RESPOSTA
                                                                                    }
                                                                                    value={
                                                                                        resposta.ID_RESPOSTA
                                                                                    }
                                                                                    wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                                    style={{
                                                                                        height: 35,
                                                                                        width: 35,
                                                                                    }}
                                                                                    disabled={
                                                                                        props.visualizandoFormRespondido ===
                                                                                        true
                                                                                    }
                                                                                    defaultChecked={lstPesquisaSatisfacaoRespostasFormularioHelpdesk?.some(
                                                                                        (
                                                                                            res
                                                                                        ) =>
                                                                                            res.ID_RESPOSTA ===
                                                                                            resposta.ID_RESPOSTA
                                                                                    )}
                                                                                />
                                                                            ) : null}
                                                                        </li>
                                                                    </React.Fragment>
                                                                )
                                                            )}
                                                        </>
                                                    ) : null}
                                                </ul>
                                            </div>
                                        )
                                    )}

                                    <hr />
                                </div>
                            )
                        )}
                    </UnForm>
                </div>
            </OrSpinner>
        </>
    );
}
